class TabCommunication {
    static sendRefreshSignal() {
      localStorage.setItem('refreshTabs', Date.now().toString());
    }
  
    static addRefreshListener(callback) {
      window.addEventListener('storage', (event) => {
        if (event.key === 'refreshTabs') {
          callback();
        }
      });
    }
  }
  
  export default TabCommunication;